import React from 'react';
import PropTypes from 'prop-types';

import { isMobile } from 'react-device-detect';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Icon from '@material-ui/core/Icon';
import Typography from '@wui/basics/typography';
import SuccessCaptureImage from '@a/images/success-capture.png';
import SuccessCaptureTwoImage from '@a/images/success-capture-2.png';
import SuccessCaptureThreeImage from '@a/images/success-capture-3.png';
import SuccessCaptureFourImage from '@a/images/success-capture-4.png';
import SuccessCaptureFiveImage from '@a/images/success-capture-5.png';
import FailCaptureOneImage from '@a/images/failed-capture-one.png';
import FailCaptureTwoImage from '@a/images/failed-capture-two.png';
import FailCaptureThreeImage from '@a/images/failed-capture-three.png';
import FailCaptureFourImage from '@a/images/failed-capture-four.png';
import FailCaptureFiveImage from '@a/images/failed-capture-five.png';
import FailCaptureSixImage from '@a/images/failed-capture-six.png';
import FailCaptureSevenImage from '@a/images/failed-capture-seven.png';
import FailCaptureEightImage from '@a/images/failed-capture-eight.png';
import FailCaptureNineImage from '@a/images/failed-capture-nine.png';
import FailCaptureTenImage from '@a/images/failed-capture-ten.png';

import './TipsExamples.scss';

const TipsExamples = ({ isPassport }) => {
  const passportCaptureTips = [
    'Make sure that the image shows your photograph, name, and signature clearly',
    'Make sure that the passport fills the majority of the frame',
    'Make sure that there is no glare on the passport',
    'Make sure that your are in a well lit area',
    'Hold the passport steady',
  ];

  const passportRequirements = [
    'Is current and not expired.',
    "Contains the signer's photograph.",
    "Contains the signer's signature.",
    'U.S. or foreign passports in English are accepted.',
    'First and last name matches Estate Planning documents.',
  ];

  const idCaptureTips = [
    'Make sure that the ID has all four corners visible',
    'Make sure that the ID covers the majority of the image',
    'Make sure that there is no glare on the ID',
    'Make sure that you are in a well lit area',
    `Hold the ${isMobile ? 'device' : 'ID'} steady`,
  ];

  const idRequirements = [
    'Is current and not expired.',
    "Contains the signer's photograph.",
    "Contains the signer's signature.",
    'First and last name matches Estate Planning documents.',
  ];

  const requirements = isPassport ? passportRequirements : idRequirements;
  const tips = isPassport ? passportCaptureTips : idCaptureTips;

  return (
    <div className="tips">
      <span>{isPassport ? 'Passport' : 'ID'} Requirements:</span>
      <ul>
        {requirements.map((req, i) => (
          <li key={i}>{req}</li>
        ))}
      </ul>
      <span>Tips:</span>
      <ul>
        {tips.map((tip, i) => (
          <li key={i}>{tip}</li>
        ))}
      </ul>
      <Container fixed className="container-example">
        <Box className="box-example">
          <Box className="box-black box-success">
            <Box display="flex" maxWidth="300px">
              <Icon style={{ color: '#28A48F', marginRight: '16px' }}>check_circle</Icon>
              <Typography style={{ color: '#fff', fontSize: '16px' }}>
                Successful caputre examples
              </Typography>
            </Box>
            <Box className="box-success-images">
              {!isPassport && (
                <>
                  <img src={SuccessCaptureImage} />
                  <img src={SuccessCaptureTwoImage} />
                  <img src={SuccessCaptureThreeImage} />
                  <img src={SuccessCaptureFourImage} />
                </>
              )}
              {isPassport && <img src={SuccessCaptureFiveImage} />}
            </Box>
          </Box>
          <Box className="box-black box-failed">
            <Box display="flex" maxWidth="800px">
              <Icon style={{ color: '#DE0707', marginRight: '16px' }}>cancel</Icon>
              <Typography style={{ color: '#fff', fontSize: '16px' }}>
                Failed capture examples
              </Typography>
            </Box>
            <Box className="box-failed-images">
              {!isPassport && (
                <>
                  <img src={FailCaptureOneImage} className="image-failed" />
                  <img src={FailCaptureThreeImage} className="image-failed" />
                  <img src={FailCaptureFiveImage} className="image-failed" />
                  <img src={FailCaptureSevenImage} className="image-failed" />
                  <img src={FailCaptureEightImage} className="image-failed" />
                  <img src={FailCaptureNineImage} className="image-failed" />
                  <img src={FailCaptureTenImage} className="image-failed" />
                </>
              )}
              {isPassport && (
                <>
                  <img src={FailCaptureFourImage} className="image-failed" />
                  <img src={FailCaptureTwoImage} className="image-failed" />
                  <img src={FailCaptureSixImage} className="image-failed" />
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Container>
    </div>
  );
};

TipsExamples.propTypes = {
  onChange: PropTypes.func.isRequired,
  isPassport: PropTypes.bool,
};

TipsExamples.defaultProps = {
  isPassport: null,
};

export default TipsExamples;
